export function formatRepetitionId(id: number): string {
  return id.toString().padStart(2, '0');
}

export function formatShotScore(score: number | undefined | null): string {
  return score != null ? score.toString() : '-';
}


export function formatHitRatio(n_hits: number, hits_ratio: number): string {
  if (!hits_ratio || hits_ratio <= 0) return `${n_hits}/0`;
  const total = Math.round(n_hits / hits_ratio);
  return `${n_hits}/${total}`;
}

export function formatHitFactor(hitFactor: number | undefined | null): string {
  return hitFactor !== null && hitFactor !== undefined ? hitFactor.toFixed(2) : '-';
}

export function formatAccuracy(score: number | undefined | null): string {
  return score !== null && score !== undefined
    ? score.toFixed(2)
    : '-';
}

export function formatDuration(seconds: number | undefined | null): string {
  if (seconds === null || seconds === undefined || seconds < 0) return '-';

  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);

  return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
}

export function calculateDurationLabel(start?: string, end?: string | null): string {
  if (!start || !end) return 'N/A';
  const startDate = new Date(start);
  const endDate = new Date(end);
  if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) return 'N/A';

  const diff = endDate.getTime() - startDate.getTime();
  const minutes = Math.floor(diff / 60000);
  const seconds = Math.floor((diff % 60000) / 1000);
  return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
}
